module.exports = __webpack_public_path__ + "static/media/folder-icon.4ed63a0c.svg";